import { ReactComponent as ChevronRight } from '../icons/chevron-right.svg'

export default function Pagination({ pageIndex, totalPages, setPage, radius = 4 }) {
  let items = [
    { type: 'page', page: 0 },
  ]
  if (pageIndex > radius) {
    items.push({ type: 'trunc' })
  }
  for (let i = pageIndex - radius; i <= pageIndex + radius; i++) {
    if (i > 0 && i < totalPages) {
      items.push({ type: 'page', page: i })
    }
  }
  if (items[items.length - 1].page !== totalPages - 1) {
    items.push({ type: 'trunc' })
    items.push({ type: 'page', page: totalPages - 1 })
  }

  let hasPrev = pageIndex > 0
  let hasNext = pageIndex < totalPages - 1

  return <>
    {items.map((item, index) =>
      item.type === 'page' ? (
        <button
          key={index}
          className={`text-primary p-1 px-1 ${pageIndex === item.page ? '' : 'opacity-30'}`}
          onClick={() => setPage(item.page)}
        >
          {item.page + 1}
        </button>
      ) :
        (
          <span key={index} className='text-primary opacity-30'>&hellip;</span>
        )

    )}

    <button
      onClick={() => setPage(pageIndex - 1)}
      disabled={!hasPrev}
      className={`w-5 h-5 dark:bg-[#0DD99C1C] rounded-md shadow-md flex items-center justify-center ${hasPrev ? '' : 'opacity-30'}`}
    >
      <ChevronRight className='w-2 h-auto rotate-180 ' />
    </button>
    <button
      onClick={() => setPage(pageIndex + 1)}
      disabled={!hasNext}
      className={`w-5 h-5 dark:bg-[#0DD99C1C] rounded-md shadow-md flex items-center justify-center ${hasNext ? '' : 'opacity-30'}`}>
      <ChevronRight className='w-2 h-auto' />
    </button>
  </>
}